import React, { useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Avatar, Layout, Menu, Typography } from 'antd';
import FullScreenButton from 'src/components/common/FullScreenButton';
import { MenuUnfoldOutlined, MenuFoldOutlined, LogoutOutlined, CloseCircleOutlined, SettingOutlined } from '@ant-design/icons';
import queryString from 'query-string';
import { useApolloClient } from '@apollo/client';
import VimeoVideo from 'src/components/common/VimeoVideo';
import ReturnToManagerBar from 'src/components/common/ReturnToManagerBar';
import styled from 'styled-components';

import { isLogedIn, userInfoVar, userVar } from 'src/apollo/cache';
import { USER_ME } from 'src/operations/queries/getUser';
import { useQueryProxy } from 'src/operations/proxy/user';
import { getCurrentToken } from '../../utils';
import { storage, useModal } from 'src/utils/hooks';
import { useSelector } from 'react-redux';
import { classStoreData } from 'src/operations/store';
import { isAfterSchool } from 'src/utils';

const { Header: HeaderWrapper } = Layout;
const { SubMenu } = Menu;
const { Text } = Typography;

const HeaderAICoach = styled(HeaderWrapper)`
  display: flex;
  flex-direction: row;
  justify-content: 'space-between';
  height: 75px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: transparent;
  /* background-image: ${(props) => !props.isStatic && `url('/images/cloud.png')`};
  background-position: ${(props) => !props.isStatic && `center bottom`};
  background-repeat: ${(props) => !props.isStatic && 'no-repeat'}; */
`;

const ImgButton = styled.img`
  cursor: pointer;
  width: 43px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

const Header = ({ collapsed, onCollapse, isStatic = false }) => {
  const companyName = useSelector(classStoreData);
  const isEpublic = companyName === 'epublic';
  const aiCoachPrimaryColor = '#1F317D';
  const history = useHistory();
  const location = useLocation();
  const token = getCurrentToken();
  const client = useApolloClient();
  const userType = useMemo(() => {
    if (userInfoVar()) {
      return userVar()[userInfoVar().type];
    }
    return '';
  }, []);
  const guideVideosForAfterSchool = useSelector((state) => state.jsonData.guideVideosForAfterSchool);
  const { data } = useQueryProxy(USER_ME, { variables: { token } });

  const onLogout = () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      isLogedIn(false);
      userInfoVar(null);
      client.clearStore();
      client.cache.gc();
      storage.removeItem('culp_token');
      window.location.reload();
    } else {
      return;
    }
  };

  const returnId = useMemo(() => {
    return window.localStorage.getItem('culp_return_id');
  }, []);

  const rightContent = (
    <>
      <Menu
        key="user"
        mode="horizontal"
        style={{ height: '100%', background: 'transparent', border: 0, flex: 8, display: 'flex', justifyContent: 'flex-end' }}
      >
        {/* another guide video btn  */}
        {isAfterSchool(companyName) && ['campus', 'manager'].includes(userType) && ['/dashboard', '/'].includes(location.pathname) && (
          <Menu.Item key="info" style={{ paddingTop: '10px' }}>
            <VimeoVideo
              width={35}
              marginTop={14}
              thumpImage="/images/guide.png"
              item={guideVideosForAfterSchool && guideVideosForAfterSchool[companyName]?.[14]?.videos}
            />{' '}
          </Menu.Item>
        )}
        <Menu.Item key="info" style={{ paddingTop: '10px' }}>
          <FullScreenButton
            element={
              isEpublic ? (
                <img
                  className="header-btn"
                  src="/images/fullscreen_blue.png"
                  alt="back arrow in header"
                  style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                />
              ) : (
                <ImgButton className="header-btn" src="/images/fullscreen.png" alt="back arrow in header" />
              )
            }
            activeElement={
              isEpublic ? (
                <img
                  className="header-btn"
                  src="/images/fullscreenExit_blue.png"
                  alt="back arrow in header"
                  style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                />
              ) : (
                <ImgButton className="header-btn" src="/images/fullscreenExit.png" alt="back arrow in header" />
              )
            }
          />
        </Menu.Item>
        {/*  */}
        <SubMenu
          key="SubMenu"
          title={
            <>
              <Avatar

              //src="//image.zuiidea.com/photo-1487412720507-e7ab37603c6f.jpeg?imageView2/1/w/200/h/200/format/webp/q/75|imageslim"
              />
              <span style={{ color: '#000', marginLeft: 10 }}>
                <span className="username">
                  {data?.me?.name} <Text strong>({data?.me?.view_id})</Text>
                </span>
                <span onClick={onLogout} style={{ color: '#999', marginLeft: 20 }}>
                  로그아웃
                  <LogoutOutlined
                    style={{
                      marginLeft: 5,
                      verticalAlign: 'middle',
                      fontSize: 25,
                      color: '#ccc',
                    }}
                    key="logout"
                  />
                </span>
              </span>
            </>
          }
        >
          {/* <Menu.Item key="SignOut" onClick={onLogout}>
            <span>Sign out</span>
          </Menu.Item> */}
        </SubMenu>
        {window.Android ? (
          <Menu.Item key="close" onClick={() => window.Android.closeApp()}>
            <span style={{ color: '#999' }}>
              <CloseCircleOutlined
                style={{
                  marginLeft: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#ccc',
                }}
                key="close"
              />
            </span>
          </Menu.Item>
        ) : null}
      </Menu>
    </>
  );

  return (
    <>
      {returnId && <ReturnToManagerBar returnId={returnId} />}
      <HeaderAICoach
        isStatic={isStatic}
        style={{
          position: isStatic ? 'fixed' : 'relative',
          // justifyContent: 'start',
          // alignItems: 'center',
          // height: '75px',
          // padding: '25px 65px',
          backgroundColor: isEpublic ? '#fff' : aiCoachPrimaryColor,
          color: isEpublic ? aiCoachPrimaryColor : '#DEEBF7',
          fontSize: '40px',
        }}
      >
        <div
          style={{
            visibility: `${userInfoVar()?.level_test === 1 ? 'hidden' : 'visible'}`,
            flex: 1,
            color: isEpublic ? aiCoachPrimaryColor : undefined,
          }}
        >
          <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
            {collapsed ? (
              <MenuFoldOutlined
                style={{
                  fontSize: 35,
                  color: isEpublic ? aiCoachPrimaryColor : undefined,
                }}
                className="trigger"
                onClick={onCollapse}
              />
            ) : (
              <MenuUnfoldOutlined
                style={{
                  fontSize: 35,
                  color: isEpublic ? aiCoachPrimaryColor : undefined,
                }}
                className="trigger"
                onClick={onCollapse}
              />
            )}
            {!isStatic && (
              <div
                onClick={() => {
                  companyName !== 'epublic' && history.push('/');
                }}
                style={{ cursor: companyName !== 'epublic' && 'pointer', padding: '0 20px', width: '400px' }}
              >
                {' '}
                <div>AI WRITING COACH</div>
              </div>
            )}
            {/* {isExistPPT && (
              <h3
                style={{
                  height: '80%',
                  margin: '0 0 0 20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  textWrap: 'nowrap',
                }}
                onClick={() => {
                  window.open(pptLink, '_blank');
                }}
              >
                <img style={{ height: '70%', margin: '0 5px 0 0' }} src="/images/v-tube-guide.png"></img>
                {` ${guideText}`}
              </h3>
            )} */}
          </div>
        </div>
        {!isStatic ? <>{rightContent}</> : null}
      </HeaderAICoach>

      {/* {userType === 'fc' && (
        <TeacherModal userInfo={userInfo?.getUserData} popupMode="edit" handleCancel={handleCancel} visible={visible} myInfo={true} />
      )}
      {userType === 'campus' && (
        <CampusModal
          campusInfo={userInfo?.getUserData?.campus}
          popupMode="edit"
          handleCancel={handleCancel}
          visible={visible}
          campus_idx={userInfo?.getUserData?.campus?.idx}
        />
      )}
      {userType === 'manager' && (
        <TeacherModal userInfo={userInfo?.getUserData} popupMode="edit" handleCancel={handleCancel} visible={visible} myInfo={true} />
      )}

      {userType === 'student' && (
        <StudentModal userInfo={userInfo?.getUserData} popupMode="edit" handleCancel={handleCancel} visible={visible} myInfo={true} />
      )}
      <OpenAiModal
        visible={openAiModal}
        handleCancel={() => {
          setOpenAiModal(false);
        }}
      /> */}
    </>
  );
};

export default Header;
